import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

export const PdfTabLayout = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  margin-top: 1rem;
`

export const PdfTabIntro = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
  align-items: flex-start;
`

export const PdfTemplateCard = styled.div`
  background-color: white;
  border: 1px solid var(--neutral-100, #e5e9ed);
  border-radius: 0.75rem;
  box-shadow: 0 1px 2px rgba(18, 43, 51, 0.06);
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
`

export const PdfTemplateHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
`

export const PdfTemplateTitle = styled.div`
  ${font('sm', 'bold')}
  color: var(--colour-text-primary, #222b33);
`

export const PdfBadge = styled.span`
  ${font('xs', 'regular')}
  padding: 0.0625rem 0.5rem;
  border-radius: 1rem;
  border: 1px solid var(--neutral-150, #d8dee4);
  background-color: var(--colour-fill-neutral-lightest, #f2f4f6);
  color: var(--colour-text-secondary, #607890);
`

export const PdfActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.25rem 1rem;
  margin-left: -0.375rem;
`

export const PdfFieldsPanel = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
  border-top: 1px solid var(--neutral-100, #e5e9ed);
  padding-top: 0.75rem;
  padding-right: 0.75rem;
  max-height: 20rem;
  overflow-y: auto;
`

export const PdfFieldRow = styled.div`
  ${font('xs', 'regular')}
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: 0.5rem;
  padding-right: 0.5rem;
  color: var(--colour-text-primary, #222b33);
`

export const PdfFieldMapped = styled.span`
  ${font('xs', 'regular')}
  color: #2f8a4e;
`

export const PdfFieldNotMapped = styled.span`
  ${font('xs', 'regular')}
  color: var(--colour-text-danger, #d4285a);
`
